import { mergeAttributes, Node } from "@tiptap/core";

import { isolateNodeView, setNodeViewAttrs } from "@/wc/editor/adapters/utils.ts";
import { NWImageProps } from "./index.tsx";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    nwImage: {
      /**
       * Add an NWImage
       */
      setNWImage: (options: { src: string; alt?: string; title?: string }) => ReturnType;
    };
  }
}

export const NWImageAdapter = Node.create<NWImageProps>({
  name: "nw-image",
  group: "inline",
  inline: true,
  draggable: false,
  atom: true,
  selectable: false,

  addOptions() {
    return {
      src: "",
      alt: "",
    };
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      withBorder: {
        default: false,
      },
      withSpacing: {
        default: true,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "nw-image",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["nw-image", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("nw-image");

      setNodeViewAttrs(dom, node.attrs);

      return isolateNodeView({ dom });
    };
  },

  addCommands() {
    return {
      setNWImage:
        options =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
